import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-sanierung-help-button',
    templateUrl: './sanierung-help-button.component.html',
    standalone: false
})
export class SanierungHelpButtonComponent {
  @Input() toggles: {[key: string]: boolean};
  @Input() toggleName: string;
}
